import OptGroup from './OptGroup';
import Option from './Option';
import SelectPropTypes from './PropTypes';
import Select from './Select';
Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;


//////////////////
// WEBPACK FOOTER
// ../~/rc-select/es/index.js
// module id = 757
// module chunks = 1